const DEFAULT_CONFIG = {
	//标题
	APP_NAME: process.env.VUE_APP_TITLE,
	//首页地址
	DASHBOARD_URL: "/dashboard",

	//版本号
	APP_VER: "0.0.1",

	//内核版本号
	CORE_VER: "0.0.1",

	//接口地址
	API_URL: process.env.VUE_APP_API_BASEURL,

	// 除/api的接口地址
	BASE_URL: process.env.VUE_APP_BASEURL,

	//请求超时
	TIMEOUT: 30000,

	//TokenName
	TOKEN_NAME: "Authorization",

	//Token前缀，注意最后有个空格，如不需要需设置空字符串
	TOKEN_PREFIX: "Bearer ",

	//追加其他头
	HEADERS: {},

	//请求是否开启缓存
	REQUEST_CACHE: true,

	//布局 默认：default | 通栏：header | 经典：menu | 功能坞：dock
	//dock将关闭标签和面包屑栏
	LAYOUT: "menu",

	//菜单是否折叠
	MENU_IS_COLLAPSE: false,

	//菜单是否启用手风琴效果
	MENU_UNIQUE_OPENED: true,

	//是否开启多标签
	LAYOUT_TAGS: true,

	//语言
	LANG: "zh-cn",

	//主题颜色
	COLOR: "#3493f3",

	//是否加密localStorage, 为空不加密，可填写AES(模式ECB,移位Pkcs7)加密
	LS_ENCRYPTION: "AES",

	//localStorageAES加密秘钥，位数建议填写8的倍数
	LS_ENCRYPTION_key: "2XNN4K8LC0ELVWN4",

	//控制台首页默认布局
	DEFAULT_GRID: {
		//默认分栏数量和宽度 例如 [24] [18,6] [8,8,8] [6,12,6]
		layout: [24, 16, 8],
		//小组件分布，com取值:views/home/components 文件名
		copmsList: [["statistic", "welcome"], ["chart"], ["time", "progress"]],
	},
};

//合并业务配置
import MY_CONFIG from "./myConfig";
Object.assign(DEFAULT_CONFIG, MY_CONFIG);

// 如果生产模式，就合并动态的APP_CONFIG
// public/config.js
console.log(process.env.NODE_ENV);
if (process.env.NODE_ENV === "production") {
	Object.assign(DEFAULT_CONFIG, APP_CONFIG);
}
// 特殊路由跳转
// var urlhash = window.location.hash;
// if (!urlhash.match("fromapp")) {
// 	if (navigator.userAgent.match(/(iPhone|iPod|Android|ios|iPad)/i)) {
// 		window.location = "http://121.229.113.186/mob/index.html";
// 	}
// }
export default DEFAULT_CONFIG;
